import { Check } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";

// Tarjetas de precios B2B
export const PriceCards = ({ tiers, accent = "#FF8A80" }) => (
  <Stagger className="grid gap-6 md:grid-cols-2">
    {tiers.map((t) => {
      const tierId = t.name.toLowerCase().replace(/[^a-z0-9]/g, "-");
      return (
      <StaggerItem
        key={t.name}
        data-testid={`price-card-${tierId}`}
        className={`relative flex flex-col rounded-[2rem] p-8 ${
          t.highlight
            ? "bg-ink text-cream shadow-[0_20px_40px_rgb(0,0,0,0.15)]"
            : "bg-white text-ink shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
        }`}
      >
        {t.highlight && (
          <span
            className="absolute right-6 top-6 rounded-full px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-ink"
            style={{ backgroundColor: accent }}
          >
            Recomendado
          </span>
        )}
        <p
          data-testid={`price-card-name-${tierId}`}
          className={`font-mono text-xs uppercase tracking-widest ${
            t.highlight ? "text-mint" : "text-ink/40"
          }`}
        >
          {t.name}
        </p>
        <div className="mt-4 flex items-end gap-2">
          <span data-testid={`price-card-price-${tierId}`} className="font-display text-5xl font-extrabold tracking-tighter">
            {t.price}
          </span>
        </div>
        <p
          className={`mt-1 font-mono text-xs uppercase tracking-widest ${
            t.highlight ? "text-cream/50" : "text-ink/40"
          }`}
        >
          MXN · {t.unit}
        </p>
        {(t.type || t.acts || t.idealFor) && (
          <div className={`mt-6 border-y py-4 ${t.highlight ? "border-white/15" : "border-ink/10"}`}>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className={`font-mono text-[10px] uppercase tracking-widest ${t.highlight ? "text-cream/45" : "text-ink/40"}`}>Tipo de cliente</p>
                <p className="mt-1 text-sm font-semibold">{t.type}</p>
              </div>
              <div>
                <p className={`font-mono text-[10px] uppercase tracking-widest ${t.highlight ? "text-cream/45" : "text-ink/40"}`}>Actos cubiertos</p>
                <p className="mt-1 text-sm font-semibold">{t.acts}</p>
              </div>
            </div>
            <p className={`mt-4 text-sm leading-relaxed ${t.highlight ? "text-cream/80" : "text-ink/70"}`}><span className="font-semibold">Ideal para: </span>{t.idealFor}</p>
          </div>
        )}
        <ul className="mt-7 flex-1 space-y-3">
          {t.features.map((f) => (
            <li key={f} className="flex items-start gap-3">
              <span
                className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
                style={{ backgroundColor: accent }}
              >
                <Check className="h-3 w-3 text-ink" strokeWidth={3} />
              </span>
              <span className={t.highlight ? "text-cream/85" : "text-ink/75"}>
                {f}
              </span>
            </li>
          ))}
        </ul>
        <a
          href="#contacto"
          data-testid={`price-cta-${tierId}`}
          className="mt-8 inline-flex items-center justify-center rounded-full px-6 py-3.5 font-semibold transition-all hover:-translate-y-0.5"
          style={{ backgroundColor: accent, color: "#2D3436" }}
        >
          Solicitar propuesta
        </a>
      </StaggerItem>
      );
    })}
  </Stagger>
);
